import lang from './lang';

const translations = {
  en: {
    gallery: 'World Tour now',
    experience: 'Join the',
  },
  tc: {
    gallery: '世界巡遊',
    experience: '立即參與',
  },
  sc: {
    gallery: '世界巡游',
    experience: '立即参与',
  },
};

export default translations[lang];










